import React, { Component } from 'react';
import memoize from 'memoize-one';
import PropTypes from 'prop-types';

import CreateCampaignFormContext from './CreateCampaignFromContext';
import ConnectedTextField from '../../../../components/_atomic/ConnectedTextField/ConnectedTextField';
import CheckBoxGroup from '../../../../components/_molecules/CheckBoxGroup/CheckBoxGroup';
import CopyValue from '../../../../components/_molecules/CopyValue/CopyValue';
import CustomMultiSelect from '../../../../components/_molecules/CustomMultiSelect/CustomMultiSelect';
import CurrencyField from '../../../../components/_molecules/CurrencyField/CurrencyField';
import {
  AUTH_STATES,
  CONTEXT_PROVIDERS,
  CPI_VALUES,
  // DAILY_BUDGET_VALUES,
  ERROR,
  LOADING,
  TEXT_FIELD_STATUS,
} from '../../../../utils/constants';
import ErrorModal from '../../../../components/_molecules/ErrorModal/ErrorModal';
import LoadingOverlay from '../../../../components/_molecules/LoadingOverlay/LoadingOverlay';
import Button from '../../../../components/_atomic/Button/Button';
import CustomToggle from '../../../../components/_molecules/CustomToggle/CustomToggle';

import platformsNonClickable from './assets/platformsNonClickable';
import './CreateCampaignForm.scss';
import { currencyToCents, formatNumber, getFieldCountryState, getFieldInitialState } from '../../../../utils/helpers';
import TextField from '../../../../components/_atomic/TextField/TextField';
import Modal from '../../../../components/_molecules/Modal/Modal';
import ModalGeoData from './components/ModalGeoData/ModalGeoData';
import { getCompanyMedias } from '../../../../reducers/create-campaign/api';
import CustomMultiSelectSex from '../../../../components/_molecules/CustomMultySelectSex/CustomMultySelectSex';
import CustomMultiSelectAge from '../../../../components/_molecules/CustomMultySelectAge/CustomMultySelectAge';
import ArrowButton from '../../../../components/_atomic/ArrowButton/ArrowButton';

const facebookLogo = require('./assets/facebook.svg');
const instagramLogo = require('./assets/instagram.svg');
const googleLogo = require('./assets/adwords.svg');
const myTargetLogo = require('./assets/mytarget.svg');
const tiktokLogo = require('./assets/TikTok.svg');
const vkLogo = require('./assets/vk.svg');

const platformInfo = {
  facebook: {
    logo: facebookLogo,
    label: 'Facebook',
  },
  instagram: {
    logo: instagramLogo,
    label: 'Instagram',
  },
  google: {
    logo: googleLogo,
    label: 'Google Adwords',
  },
  mytarget: {
    logo: myTargetLogo,
    label: 'My Target',
  },
  tiktok: {
    logo: tiktokLogo,
    label: 'TikTok',
  },
  vk: {
    logo: vkLogo,
    label: 'TikTok',
  },
};

const campaignTextFieldName = 'campaign-name';
const platformsCheckGroupName = 'platforms';
const countriesSelectName = 'countries';
const genderFieldName = 'targetSex';
const ageFieldName = 'targetAge';
const targetActionFieldName = 'target-action';
const cpiFieldName = 'cpi';
const autoCPIFieldName = 'auto-cpi';
const dailyBudgetFieldName = 'daily-budget';
const activeCampaignFieldName = 'active-campaign';
const platformsValues = ['facebook', 'instagram', 'google', 'mytarget', 'tiktok', 'vk'];
const SelectIdentify = 'countries-identify';

class CreateCampaignForm extends Component {
  static propTypes = {
    countries: PropTypes
      .arrayOf(PropTypes.shape())
      .isRequired,
    getApps: PropTypes.func.isRequired,
    apps: PropTypes
      .arrayOf(PropTypes.shape({}))
      .isRequired,
    submitHandler: PropTypes.func.isRequired,
    createCampaignStatus: PropTypes.string.isRequired,
    createCampaignError: PropTypes.string.isRequired,
    patchCampaignStatus: PropTypes.string.isRequired,
    patchCampaignError: PropTypes.string.isRequired,
    annulError: PropTypes.func.isRequired,
    annulPatchError: PropTypes.func.isRequired,
    formState: PropTypes
      .shape({})
      .isRequired,
    resetCampaignStore: PropTypes.func.isRequired,
    isAuthorized: PropTypes.string.isRequired,
    appId: PropTypes.string,
    campaignId: PropTypes.string,
    isFirstFlow: PropTypes.bool.isRequired,
    currentEditableCampaign: PropTypes
      .shape({})
      .isRequired,
    getCampaign: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
    patchCampaign: PropTypes.func.isRequired,
    sidebarStatus: PropTypes.bool,
  }
  static defaultProps = {
    appId: '',
    campaignId: '',
    isAdmin: false,
    sidebarStatus: true,
  }
  constructor() {
    super();
    this.fields = {};
  }

  state = {
    fields: {
      [campaignTextFieldName]: getFieldInitialState(),
      [platformsCheckGroupName]: getFieldInitialState(undefined, undefined, []),
      [countriesSelectName]: getFieldInitialState(undefined, undefined, []),
      [targetActionFieldName]: getFieldInitialState(),
      [genderFieldName]: getFieldInitialState(),
      [ageFieldName]: getFieldInitialState(),
      [cpiFieldName]: getFieldInitialState(undefined, undefined, []),
      [autoCPIFieldName]: getFieldInitialState(undefined, undefined, []),
      [dailyBudgetFieldName]: getFieldInitialState(undefined, undefined, 0),
      [activeCampaignFieldName]: getFieldInitialState(TEXT_FIELD_STATUS.VALID, undefined, false),
    },
    fieldsCountry: {
      [SelectIdentify]: getFieldCountryState([], []),
    },
    medias: [],
    locations: [],
    localLocationEdit: null,
    statusUpdate: false,
    modalGeoData: false,
    cpiCurrentPlatform: '',
    statusCpiUpdate: false,
    statusDailyBudgetUpdate: false,
    cpi: [
      { platform: 'facebook', value: '0.10', isDisabled: [] },
      { platform: 'instagram', value: '0.10', isDisabled: [] },
      { platform: 'google', value: '0.10', isDisabled: [] },
      { platform: 'mytarget', value: '0.10', isDisabled: [] },
      { platform: 'tiktok', value: '0.10', isDisabled: [] },
      { platform: 'vk', value: '0.10', isDisabled: [] },
    ],
    dailyBudget: [
      { platform: 'facebook', value: '10.00', isDisabled: [] },
      { platform: 'instagram', value: '10.00', isDisabled: [] },
      { platform: 'google', value: '10.00', isDisabled: [] },
      { platform: 'mytarget', value: '10.00', isDisabled: [] },
      { platform: 'tiktok', value: '10.00', isDisabled: [] },
      { platform: 'vk', value: '10.00', isDisabled: [] },
    ],
  };
  componentWillMount() {
    const {
      getApps, formState, apps, campaignId, getCampaign,
    } = this.props;
    if (!apps.length) {
      getApps();
    }
    if (formState.hasState) {
      let { fields } = {
        ...this.state.fields,
      };
      fields = {
        ...formState.data,
      };
      this.setState(() => ({ fields }));
    }
    if (campaignId) {
      getCampaign({ campaignId });
      getCompanyMedias(campaignId)
        .then((res) => {
          const medias = res.data;
          // eslint-disable-next-line react/no-unused-state
          this.setState({ medias });
        });
    }
  }
  componentDidMount() {
  }
  componentDidUpdate(prevProps) {
    const { currentEditableCampaign } = this.props;
    const { statusCpiUpdate, statusDailyBudgetUpdate } = this.state;
    if (currentEditableCampaign.cpi && currentEditableCampaign.cpi.length > 0) {
      if (!statusCpiUpdate) {
        const { cpi } = this.state;
        const platformsActive = currentEditableCampaign.cpi;
        platformsActive.forEach((pl) => {
          cpi.forEach((st) => {
            if (pl.platform.toLowerCase() === 'adwords' || pl.platform.toLowerCase() === st.platform) {
              const formatToStringRow = formatNumber(pl.value, 'CPI');
              // eslint-disable-next-line no-param-reassign
              st.value = formatToStringRow.toFixed(2);
              if (formatToStringRow.toFixed(2) === '0.10') {
                // eslint-disable-next-line no-param-reassign
                st.isDisabled = ['auto'];
              }
            }
          });
        });
        this.setState({ statusCpiUpdate: true });
      }
    }
    if (currentEditableCampaign.dailyBudget && currentEditableCampaign.dailyBudget.length > 0) {
      if (!statusDailyBudgetUpdate) {
        const { dailyBudget } = this.state;
        const platformsActive = currentEditableCampaign.dailyBudget;
        platformsActive.forEach((pl) => {
          dailyBudget.forEach((st) => {
            if (pl.platform.toLowerCase() === 'adwords' || pl.platform.toLowerCase() === st.platform) {
              const formatToStringRow = formatNumber(pl.value, 'CPI');
              // eslint-disable-next-line no-param-reassign
              st.value = formatToStringRow.toFixed(2);
            }
          });
        });
        this.setState({ statusDailyBudgetUpdate: true });
      }
    }
    if (currentEditableCampaign
      && currentEditableCampaign.id !== prevProps.currentEditableCampaign.id) {
      const fields = {
        ...this.state.fields,
      };
      const fieldsCountry = {
        ...this.state.fieldsCountry,
      };
      fields[campaignTextFieldName].value = currentEditableCampaign.name;
      fields[genderFieldName].value = currentEditableCampaign.targetSex;
      fields[ageFieldName].value = currentEditableCampaign.targetAge;
      fields[platformsCheckGroupName].value = currentEditableCampaign.platforms && Object
        .keys(currentEditableCampaign.platforms)
        .filter(platformName => currentEditableCampaign.platforms[platformName]);
      fields[platformsCheckGroupName].status = TEXT_FIELD_STATUS.VALID;
      fields[countriesSelectName].value =
          currentEditableCampaign.geos.map(geo => ({
            value: geo.id,
            label: geo.countryName,
            cId: geo.countryId,
            rId: geo.regionId,
          }));
      fields[targetActionFieldName].value = currentEditableCampaign.targetAction;
      fields[cpiFieldName].value = currentEditableCampaign.cpi || 0;
      fields[cpiFieldName].isDisabled = currentEditableCampaign.cpi === null;
      fields[autoCPIFieldName].value = currentEditableCampaign.cpi !== null ? [] : ['auto'];
      fields[dailyBudgetFieldName].value = currentEditableCampaign.dailyBudget;
      fields[genderFieldName].value = currentEditableCampaign.targetSex;
      fields[ageFieldName].value = currentEditableCampaign.targetAge;
      fields[activeCampaignFieldName].value = currentEditableCampaign.status;
      this.setState(() => ({ fields }));
      fieldsCountry[SelectIdentify].value =
          currentEditableCampaign.geos.map(geo => ({
            cityId: geo.cityId,
            countryId: geo.countryId,
            regionId: geo.regionId,
          }));
      this.setState(() => ({ fieldsCountry }));
    }
  }
  componentWillUnmount() {
    const {
      resetCampaignStore, isAuthorized, isFirstFlow,
    } = this.props;

    if (isAuthorized === AUTH_STATES.DEAUTH && !isFirstFlow) {
      resetCampaignStore();
    }
  }
  getFormStatus = (fields) => {
    let status = TEXT_FIELD_STATUS.INITIAL;
    let validFields = 0;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    /* calc invalid fields coz form can have one VALID and one INITIAL field
               then form isn't valid or invalid it is initial */
    fieldsNames.forEach((name) => {
      if (fields[name].status === TEXT_FIELD_STATUS.VALID) {
        validFields += 1;
      }
      if (fields[name].status === TEXT_FIELD_STATUS.INVALID) {
        if (fields[name].value === '0.00') {
          validFields += 1;
        } else {
          invalidFields += 1;
        }
      }
    });
    if (validFields === fieldsNames.length) {
      status = TEXT_FIELD_STATUS.VALID;
    }

    if (invalidFields > 0) {
      status = TEXT_FIELD_STATUS.INVALID;
    }
    return status;
  };
  filterGeoLocations = (data) => {
    const updateLoc = data.map(country => ({ value: country.id, label: country.name }));
    return updateLoc.filter((el, index) =>
      index === updateLoc.findIndex(elem => elem.label === el.label && elem.value === el.value));
  };
  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  };
  transformCountries =
    memoize(countries => this.filterGeoLocations(countries));

  fieldChangeHandler = ({ name, value }) => {
    const fields = {
      ...this.state.fields,
    };
    let formStatus = {
      ...this.state.formStatus,
    };
    if (name === 'daily-budget') {
      const { cpiCurrentPlatform, dailyBudget } = this.state;
      if (value.length === 0 || value[0] === 'auto') {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const pid in dailyBudget) {
          if (dailyBudget[pid].platform === cpiCurrentPlatform) {
            dailyBudget[pid].value = '10.00';
          }
        }
      } else {
        dailyBudget.forEach((el) => {
          if (el.platform === cpiCurrentPlatform) {
            // eslint-disable-next-line no-param-reassign
            el.value = value;
          }
        });
      }
    }
    if (name === 'cpi') {
      const { cpiCurrentPlatform, cpi } = this.state;
      if (value.length === 0 || value[0] === 'auto') {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const pid in cpi) {
          if (cpi[pid].platform === cpiCurrentPlatform) {
            cpi[pid].isDisabled = cpi[pid].isDisabled.length === 0 ? ['auto'] : [];
            cpi[pid].value = '0.10';
          }
        }
      } else {
        cpi.forEach((el) => {
          if (el.platform === cpiCurrentPlatform) {
            // eslint-disable-next-line no-param-reassign
            el.value = value;
          }
        });
      }
    }
    if (name === countriesSelectName) {
      const updLocation = value.map(geo => ({
        countryId: geo.cId,
      }));
      this.setState({
        localLocationEdit: {
          value: updLocation,
        },
        statusUpdate: true,
      });
      if (fields[countriesSelectName].value.length < value.length) {
        this.setState({ modalGeoData: value[value.length - 1] });
      } else {
        let locations = [];
        this.state.locations.forEach((local) => {
          let fl = false;
          value.forEach((val) => {
            if (!fl && val.value === local.countryId) fl = true;
          });
          if (fl) {
            locations = locations.concat(local);
          }
        });
        this.setState({ locations });
      }
    }
    fields[name].value = value;
    if (fields[name].status !== TEXT_FIELD_STATUS.INITIAL && !fields[name].outerError) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }
    if (name === autoCPIFieldName) {
      const isAuto = fields[name]
        .value
        .indexOf('auto') > -1;
      fields[cpiFieldName].isDisabled = isAuto;
      if (isAuto) {
        fields[cpiFieldName].status = TEXT_FIELD_STATUS.VALID;
        fields[cpiFieldName].errorText = '';
      } else {
        fields[cpiFieldName].status = TEXT_FIELD_STATUS.INITIAL;
        fields[cpiFieldName].errorText = '';
      }
    }
    this.setState(() => ({ fields, formStatus }));
  };

  fieldFocusHandler = ({ name, isFocused, value }) => {
    const fields = {
      ...this.state.fields,
    };
    let { formStatus } = {
      ...this.state.formStatus,
    };

    fields[name].isFocused = isFocused;
    if (!isFocused && value) {
      fields[name].value = value;
    }

    if (!isFocused) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      if (!fields[name].outerError) {
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
      }
      formStatus = this.getFormStatus(fields);
      // do in such "elegant" way, coz at shouldComponentUpdate nextState is equal to
      // this.state, when Context is used.
    }
    this.setState(() => ({ fields, formStatus }));
  };
  adminSubmitHandler = (e) => {
    e.preventDefault();

    const fields = {
      ...this.state.fields,
    };
    const fieldsCountry = {
      ...this.state.fieldsCountry,
    };
    const localLocationStatus = {
      ...this.state.localLocationEdit,
    };
    const { campaignId, patchCampaign } = this.props;
    const fieldCpi = this.state.cpi;
    const fieldDailyBudget = this.state.dailyBudget;
    const StatusGroup = fields[platformsCheckGroupName].value;
    const UpdateLocation = fieldsCountry[SelectIdentify].value;
    const { value: selectedValue } = fields[platformsCheckGroupName];
    /* Filter selected groups */
    const SelectedGroups = {};
    platformsValues.forEach((value) => {
      if (StatusGroup.indexOf(value) > -1) {
        SelectedGroups[value] = true;
      } else {
        SelectedGroups[value] = false;
      }
    });

    /* Fee status field */
    const platforms = {};
    platformsValues.forEach((value) => {
      if (selectedValue.indexOf(value) > -1) {
        platforms[value] = true;
      } else {
        platforms[value] = false;
      }
    });
    const cpiPlatformsStatus = [];
    fieldCpi.forEach((value) => {
      platformsValues.forEach((pl) => {
        if (selectedValue.indexOf(pl) > -1) {
          if (value.platform === pl) {
            cpiPlatformsStatus.push({
              platform: value.platform === 'google' ? 'ADWORDS' : value.platform.toUpperCase(),
              value: currencyToCents(value.value),
            });
          }
        }
      });
    });
    const dailyBudgetPlatformStatus = [];
    fieldDailyBudget.forEach((value) => {
      platformsValues.forEach((pl) => {
        if (selectedValue.indexOf(pl) > -1) {
          if (value.platform === pl) {
            dailyBudgetPlatformStatus.push({
              platform: value.platform === 'google' ? 'ADWORDS' : value.platform.toUpperCase(),
              value: currencyToCents(value.value),
            });
          }
        }
      });
    });
    if (this.state.statusUpdate === false) {
      /* Filtered counties */
      let updatedLocationCountry = null;
      if (this.state.locations.length > 0) {
        updatedLocationCountry = UpdateLocation.concat(this.state.locations);
      } else {
        updatedLocationCountry = UpdateLocation;
      }
      /* Create data and patch */
      const data = {
        adPlatforms: SelectedGroups,
        targetAction: fields[targetActionFieldName].value,
        cpi: cpiPlatformsStatus,
        dailyBudget: dailyBudgetPlatformStatus,
        locations: updatedLocationCountry,
        name: fields[campaignTextFieldName].value,
        targetSex: fields[genderFieldName].value,
        targetAge: fields[ageFieldName].value,
        status: fields[activeCampaignFieldName].value,
        campaignId,
      };
      patchCampaign(data);
    } else {
      let locations = [];
      this.state.locations.forEach((local) => {
        // eslint-disable-next-line no-unused-expressions,no-nested-ternary
        (local.city && local.city.value.length > 0) ? local.city.value.forEach((city) => {
          // eslint-disable-next-line max-len
          locations = locations.concat([{ cityId: city.value, countryId: local.countryId, regionId: local.region.value.value }]);
          // eslint-disable-next-line max-len
        }) : local.region ? locations = locations.concat([{ countryId: local.countryId, regionId: local.region.value.value, cityId: null }]) :
        // eslint-disable-next-line max-len
          locations = locations.concat([{ countryId: local.countryId, regionId: null, cityId: null }]);
      });

      const currentLocations = localLocationStatus.value;
      let updatedLocationCountry = null;
      if (locations.length > 0) {
        updatedLocationCountry = currentLocations.concat(locations);
        updatedLocationCountry = updatedLocationCountry.filter(n => n.countryId !== undefined);
      } else {
        currentLocations.filter(n => n.countryId !== undefined);
        updatedLocationCountry = currentLocations;
      }
      const data = {
        adPlatforms: SelectedGroups,
        targetAction: fields[targetActionFieldName].value,
        cpi: cpiPlatformsStatus,
        dailyBudget: dailyBudgetPlatformStatus,
        locations: updatedLocationCountry,
        name: fields[campaignTextFieldName].value,
        targetSex: fields[genderFieldName].value,
        targetAge: fields[ageFieldName].value,
        status: fields[activeCampaignFieldName].value,
        campaignId,
      };
      patchCampaign(data);
      this.setState({
        statusUpdate: false,
      });
    }
  };

  submitHandler = (e) => {
    e.preventDefault();
    const fields = {
      ...this.state.fields,
    };

    const localLocationStatus = {
      ...this.state.localLocationEdit,
    };

    const fieldsCountry = {
      ...this.state.fieldsCountry,
    };
    const fieldCpi = this.state.cpi;
    const fieldDailyBudget = this.state.dailyBudget;
    Object
      .keys(this.fields)
      .forEach((name) => {
        if (!fields[name].outerError) {
          const { validator } = this.fields[name];
          const validate = validator(fields[name].value);
          fields[name].status = validate.status;
          fields[name].errorText = validate.errorText;
        }
      });
    const formStatus = this.getFormStatus(fields);
    this.setState(() => ({ fields, formStatus }), () => {
      if (formStatus === TEXT_FIELD_STATUS.VALID) {
        const { apps, appId: currentAppId, campaignId } = this.props;
        const appId = currentAppId || apps[0].id;
        const { value: name } = fields[campaignTextFieldName];
        const { value: selectedValue } = fields[platformsCheckGroupName];
        const { value: targetAction } = fields[targetActionFieldName];
        const UpdateLocation = fieldsCountry[SelectIdentify].value;
        const StatusGroup = fields[platformsCheckGroupName].value;
        // const { value: rawDailyBudget } = fields[dailyBudgetFieldName];
        const { value: status } = fields[activeCampaignFieldName];
        const SelectedGroups = {};
        platformsValues.forEach((value) => {
          if (StatusGroup.indexOf(value) > -1) {
            SelectedGroups[value] = true;
          } else {
            SelectedGroups[value] = false;
          }
        });
        const platforms = {};
        platformsValues.forEach((value) => {
          if (selectedValue.indexOf(value) > -1) {
            platforms[value] = true;
          } else {
            platforms[value] = false;
          }
        });
        const cpiPlatformsStatus = [];
        fieldCpi.forEach((value) => {
          platformsValues.forEach((pl) => {
            if (selectedValue.indexOf(pl) > -1) {
              if (value.platform === pl) {
                cpiPlatformsStatus.push({
                  platform: value.platform === 'google' ? 'ADWORDS' : value.platform.toUpperCase(),
                  value: currencyToCents(value.value),
                });
              }
            }
          });
        });
        const dailyBudgetPlatformStatus = [];
        fieldDailyBudget.forEach((value) => {
          platformsValues.forEach((pl) => {
            if (selectedValue.indexOf(pl) > -1) {
              if (value.platform === pl) {
                dailyBudgetPlatformStatus.push({
                  platform: value.platform === 'google' ? 'ADWORDS' : value.platform.toUpperCase(),
                  value: currencyToCents(value.value),
                });
              }
            }
          });
        });
        // const dailyBudget = currencyToCents(rawDailyBudget);
        if (this.state.statusUpdate === false) {
          /* Filtered counties */
          let updatedLocationCountry = null;
          if (this.state.locations.length > 0) {
            updatedLocationCountry = UpdateLocation.concat(this.state.locations);
          } else {
            updatedLocationCountry = UpdateLocation;
          }
          const data = {
            name,
            targetSex: fields[genderFieldName].value,
            targetAge: fields[ageFieldName].value,
            locations: updatedLocationCountry,
            cpi: cpiPlatformsStatus,
            dailyBudget: dailyBudgetPlatformStatus,
          };
          if (campaignId) {
            data.status = status;
            data.adPlatforms = SelectedGroups;
            data.campaignId = campaignId;
          } else {
            data.platforms = platforms;
            data.appId = appId;
            data.targetAction = targetAction;
          }
          this
            .props
            .submitHandler(data);
        } else {
          // eslint-disable-next-line no-shadow
          let locations = [];
          this.state.locations.forEach((local) => {
            // eslint-disable-next-line no-nested-ternary,no-unused-expressions
            (local.city && local.city.value.length > 0) ? local.city.value.forEach((city) => {
              locations = locations.concat([{
                cityId: city.value,
                countryId: local.countryId,
                regionId: local.region.value.value,
              }]);
            }) : local.region ? locations = locations.concat([{
              countryId: local.countryId,
              regionId: local.region.value.value,
              cityId: null,
            }]) :
              locations = locations.concat([{
                countryId: local.countryId,
                regionId: null,
                cityId: null,
              }]);
          });
          const currentLocations = localLocationStatus.value;
          let updatedLocationCountry = null;
          if (locations.length > 0) {
            updatedLocationCountry = currentLocations.concat(locations);
            updatedLocationCountry = updatedLocationCountry.filter(n => n.countryId !== undefined);
          } else {
            currentLocations.filter(n => n.countryId !== undefined);
            updatedLocationCountry = currentLocations;
          }

          const data = {
            name,
            locations: updatedLocationCountry,
            cpi: cpiPlatformsStatus,
            dailyBudget: dailyBudgetPlatformStatus,
            targetSex: fields[genderFieldName].value,
            targetAge: fields[ageFieldName].value,
          };
          if (campaignId) {
            data.status = status;
            data.campaignId = campaignId;
            data.adPlatforms = SelectedGroups;
          } else {
            data.platforms = platforms;
            data.appId = appId;
            data.targetAction = targetAction;
          }
          this
            .props
            .submitHandler(data);
        }
      }
    });
  }
  handleSaveRegions = (data) => {
    const locations = this.state.locations.concat(data);
    this.setState({ locations, modalGeoData: false });
  };
  handleDeleteLastCountry = () => {
    const { fields } = this.state;
    fields[countriesSelectName].value.pop();
    this.setState({ fields });
  };
  updateCpiFieldRows = (cpi) => {
    this.setState({ cpi });
  }
  cpiCurrentPlatform = (platform) => {
    this.setState({
      cpiCurrentPlatform: platform,
    });
  }
  navigateToBack = () => {
    window.history.back();
  }

  renderNoEditablePlatforms = values => (
    <div className="no-editable-platforms-wrapper">
      <div className="main-label-no-transform">
        <span>
          Platforms:
        </span>
      </div>
      {values.map(value => (
        <div id={`${value}-platform-option`} className="platform-option">
          <div className="icon-wrapper"><img src={platformInfo[value].logo} alt="logo" /></div>
          <div className="platform-name">
            <span>{platformInfo[value].label}</span>
          </div>
        </div >
      ))}
    </div>
  );

  render() {
    const { fields, formStatus, medias } = this.state;
    const {
      countries,
      createCampaignStatus,
      createCampaignError,
      patchCampaignStatus,
      patchCampaignError,
      annulError,
      annulPatchError,
      isFirstFlow,
      campaignId,
      isAdmin,
      sidebarStatus,
    } = this.props;
    const campaignName = fields[campaignTextFieldName];
    const platformsCheckGroup = fields[platformsCheckGroupName];
    const countriesSelect = fields[countriesSelectName];
    const targetActionField = fields[targetActionFieldName];
    const cpiField = fields[cpiFieldName];
    const autoCPIField = fields[autoCPIFieldName];
    // const dailyBudgetField = fields[dailyBudgetFieldName];
    const genderField = fields[genderFieldName];
    const ageField = fields[ageFieldName];
    const activeCampaignField = fields[activeCampaignFieldName];
    const transformedCountries = this.transformCountries(countries);
    const isLoading = createCampaignStatus === LOADING;
    let isError = createCampaignStatus === ERROR;
    const isPatchError = patchCampaignStatus === ERROR;
    const errorMessage = createCampaignError;
    const errorPatchMessage = patchCampaignError;
    const disabledButton = formStatus === TEXT_FIELD_STATUS.INVALID;
    const buttonText = isFirstFlow
      ? 'Next'
      : 'Save';
    // eslint-disable-next-line no-unused-expressions,no-const-assign
    errorMessage === 'Country not exist' ? isError = false : null;
    return (
      <div>
        <LoadingOverlay visible={isLoading} />
        <ErrorModal requestClose={annulError} visible={isError} error={errorMessage} />
        <ErrorModal
          requestClose={annulPatchError}
          visible={isPatchError}
          error={errorPatchMessage}
        />
        {!isFirstFlow && <ArrowButton
          onClick={this.navigateToBack}
          padLeft={sidebarStatus ? 125 : 125}
        />}
        <form onSubmit={isAdmin ? this.adminSubmitHandler : this.submitHandler} className="create-campaign-form">
          <CreateCampaignFormContext.Provider
            value={{
              register: this.registerField,
              changeHandler: this.fieldChangeHandler,
              focusHandler: this.fieldFocusHandler,
            }}
          >
            {isAdmin &&
              <div className="campaign-id-field-wrapper">
                <TextField
                  status={TEXT_FIELD_STATUS.VALID}
                  disabled
                  disabledView
                  isFocused
                  value={campaignId}
                  label="Campaign ID"
                />
                <CopyValue value={campaignId} iconOnly />
              </div>
              }
            <ConnectedTextField
              name={campaignTextFieldName}
              value={campaignName.value}
              status={campaignName.status}
              isFocused={campaignName.isFocused}
              errorText={campaignName.errorText}
              isRequired
              className="campaign-name"
              label="Campaign Name"
              placeholder="Campaign Name"
              contextProvider={CONTEXT_PROVIDERS.CreateCampaignFormContext}
            />
            <div className="social-option-section">
              {!campaignId &&
                <div className="business-id">Business ID:
                  <CopyValue value="idexample" />
                </div> }
              <CheckBoxGroup
                name={platformsCheckGroupName}
                value={platformsCheckGroup.value}
                values={platformsValues}
                nonClickable={platformsNonClickable}
                header="Platforms:"
                status={platformsCheckGroup.status}
                errorText={platformsCheckGroup.errorText}
                registerField={this.registerField}
                changeHandler={this.fieldChangeHandler}
                cpiFieldState={this.state.cpi}
                cpiFieldName={cpiFieldName}
                dailyBudgetState={this.state.dailyBudget}
                dailyBudgetName={dailyBudgetFieldName}
                isAdmin={isAdmin}
                cpiCurrentPlatform={this.cpiCurrentPlatform}
                isRequired
              >
                <div className="social-option-wrapper">
                  <div id="facebook-platform-option" className="platform-option">
                    <div className="icon-wrapper"><img src={facebookLogo} alt="facebook logo" /></div>
                    <span>Facebook</span>
                  </div>
                </div>

                <div className="social-option-wrapper">
                  <div id="instagram-platform-option" className="platform-option">
                    <div className="icon-wrapper"><img src={instagramLogo} alt="facebook logo" /></div>
                    <span>Instagram</span>
                  </div>
                </div>
                <div className="social-option-wrapper">
                  <div id="google-platform-option" className="platform-option">
                    <div className="icon-wrapper"><img src={googleLogo} alt="facebook logo" /></div>
                    <span>Google Adwords</span>
                  </div>
                </div>
                <div className="social-option-wrapper">
                  <div id="mytarget-platform-option" className="platform-option">
                    <div className="icon-wrapper"><img src={myTargetLogo} alt="facebook logo" /></div>
                    <span>MyTarget</span>
                  </div>
                </div>
                <div className="social-option-wrapper">
                  <div id="tiktok-platform-option" className="platform-option">
                    <div className="icon-wrapper"><img src={tiktokLogo} alt="facebook logo" /></div>
                    <span>TikTok</span>
                  </div>
                </div>
                <div className="social-option-wrapper">
                  <div id="vk-platform-option" className="platform-option">
                    <div className="icon-wrapper"><img src={vkLogo} alt="facebook logo" /></div>
                    <span>Vkontakte</span>
                  </div>
                </div>
              </CheckBoxGroup>

            </div>
            <CustomMultiSelectAge
              registerField={this.registerField}
              status={ageField.status}
              value={ageField.value}
              name={ageFieldName}
              errorText={ageField.errorText}
              inputProps={{
                placeholder: 'Age',
              }}
              onChange={this.fieldChangeHandler}
            />
            <CustomMultiSelect
              values={transformedCountries}
              name={countriesSelectName}
              value={countriesSelect.value}
              isFocused={countriesSelect.isFocused}
              registerField={this.registerField}
              status={countriesSelect.status}
              errorText={countriesSelect.errorText}
              focusHandler={this.fieldFocusHandler}
              label="Geo"
              isRequired
              multi
              closeOnSelect={false}
              changeHandler={this.fieldChangeHandler}
            />
            <Modal
              visible={this.state.modalGeoData}
                  // requestClose={this.handleDeleteLastCountry}
            >
              {this.state.modalGeoData && <ModalGeoData
                data={this.state.modalGeoData}
                handleSaveRegions={this.handleSaveRegions}
              />}
            </Modal>
            <div className="target-action-field-wrapper">
              <ConnectedTextField
                name={targetActionFieldName}
                value={targetActionField.value}
                status={targetActionField.status}
                isFocused={targetActionField.isFocused}
                errorText={targetActionField.errorText}
                hint={targetActionField.hint}
                isRequired
                label="Target action"
                placeholder="Target action"
                contextProvider={CONTEXT_PROVIDERS.CreateCampaignFormContext}
              />
              {campaignId && <CopyValue iconOnly value={targetActionField.value} />}
            </div>
            <CustomMultiSelectSex
              isRequired
              registerField={this.registerField}
              status={genderField.status}
              value={genderField.value}
              name={genderFieldName}
              errorText={genderField.errorText}
              inputProps={{
                placeholder: 'Gender',
              }}
              onChange={this.fieldChangeHandler}
            />
            <div className="cpi-wrapper" style={{ display: 'none' }}>
              <CurrencyField
                name={cpiFieldName}
                value={cpiField.value}
                status={cpiField.status}
                isFocused={cpiField.isFocused}
                errorText={cpiField.errorText}
                hint={cpiField.hint}
                disabled={cpiField.isDisabled}
                maxValue={10000}
                isRequired
                label="CPI"
                placeholder="CPI"
                minValue={CPI_VALUES.MIN}
                contextProvider={CONTEXT_PROVIDERS.CreateCampaignFormContext}
              />
              <CheckBoxGroup
                name={autoCPIFieldName}
                value={autoCPIField.value}
                values={['auto']}
                disabled={isAdmin ? [] : []}
                registerField={this.registerField}
                changeHandler={this.fieldChangeHandler}
              >
                <span>Auto</span>
              </CheckBoxGroup>
            </div>
            {/* <CurrencyField */}
            {/* name={dailyBudgetFieldName} */}
            {/* value={dailyBudgetField.value} */}
            {/* status={dailyBudgetField.status} */}
            {/* isFocused={dailyBudgetField.isFocused} */}
            {/* errorText={dailyBudgetField.errorText} */}
            {/* hint={dailyBudgetField.hint} */}
            {/* maxValue={100000} */}
            {/* isRequired */}
            {/* label="Daily Budget" */}
            {/* placeholder="Daily Bud." */ }
            {/* minValue={DAILY_BUDGET_VALUES.MIN} */}
            {/* contextProvider={CONTEXT_PROVIDERS.CreateCampaignFormContext} */}
            { /* /> */ }
            {campaignId &&
              <div className="status-wrapper">
                <span>Status</span>
                <CustomToggle
                  value={activeCampaignField.value}
                  name={activeCampaignFieldName}
                  changeHandler={this.fieldChangeHandler}
                  registerField={this.registerField}
                />
              </div>
            }
            {medias.length > 0 &&
              <div className="medias">
                <span>Media files</span>
                {medias.map(item => (<div className="media__item" style={{ backgroundImage: `url(${item.previewURL})` }} />))}
              </div>}
          </CreateCampaignFormContext.Provider>

          <div className="button-wrapper">
            <Button
              disabled={disabledButton}
              label={buttonText}
              type="submit"
            />
          </div>
        </form>
      </div>
    );
  }
}


export default CreateCampaignForm;



// WEBPACK FOOTER //
// ./src/containers/CreateCampaign/components/CreateCampaignForm/CreateCampaignForm.js